import React, { useEffect, useState, useContext } from 'react';
import { toast } from 'react-toastify';
import Api from '../../services/Api';
import './styles.css';
import '../../App.css';
import UserContext from '../../contexts/UserContext';
import Functions from '../../services/Functions';
import ListItemVehicle from '../../components/ListItemVehicle';

export default function DashboardVehicles({ setLoading }) {
    const { user } = useContext(UserContext);
    const [vehicles, setVehicles] = useState([]);

    useEffect(() => {
        loadVehicles();
    }, []);

    async function loadVehicles() {
        try {
            setLoading(true);
            const response = await Api.getItems("get-vehicles");
            setVehicles(response);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }

    function addVehicle() {
        var vehicleCopy = Array.from(vehicles);
        vehicleCopy.unshift({
            _id: Date.now().toString(),
            placa: "",
            tara: 0,
            capacidadeKG: 0,
            capacidadeM3: 0,
            tipoRodado: "03",
            tipoCarroceria: "00",
            UF_veiculo: "RS",
            RENAVAM: "",
            Proprietario: {
                CPF_prop: "",
                CNPJ_prop: "",
                RNTRC_prop: "",
                nome_prop: "",
                IE_prop: "",
                UF_prop: "RS",
                tipo_prop: 0
            },
            Condutor: {
                nome_cond: "",
                CPF_cond: ""
            },
            active: true
        });
        setVehicles(vehicleCopy);
        setTimeout(() => {
            const headList = document.getElementsByClassName("headList")[0];
            if (headList) headList.click();
        }, 100);
    }

    async function removeVehicle(id) {
        if (id && id.toString().match(/^[0-9a-fA-F]{24}$/)) {
            if (window.confirm('Deseja realmente deletar este veículo?')) {
                try {
                    setLoading(true);
                    const response = await Api.saveItem("delete-vehicle", { id });
                    if (response && response.success) {
                        toast.success("Operação realizada com sucesso!", { position: toast.POSITION.BOTTOM_RIGHT });
                        loadVehicles();
                    } else {
                        toast.error(response?.message || "Falha ao deletar!", { position: toast.POSITION.BOTTOM_RIGHT });
                    }
                    setLoading(false);
                } catch (err) {
                    setLoading(false);
                }
            }
        } else {
            var vehicleCopy = Array.from(vehicles);
            var index = vehicleCopy.findIndex(item => item._id === id);
            if (index !== -1) {
                vehicleCopy.splice(index, 1);
                setVehicles(vehicleCopy);
            }
        }
    }

    return (
        <div id="vehicleList" className="bodyDashboard">
            <div className="v-center">
                <div className="col-6">
                    <span className="title">Veículos</span>
                </div>
                <div className="col-6 text-right">
                    <button type="button" onClick={addVehicle} className="btnNew"><i className="fa fa-plus fa-lg"></i></button>
                </div>
            </div>
            <div className="col-12">
                <ul className="dashboardList">
                    {vehicles.length > 0 ? vehicles.map(item => (
                        <ListItemVehicle
                            key={item._id}
                            item={item}
                            onDelete={() => removeVehicle(item._id)}
                            loadItem={loadVehicles}
                            setLoading={setLoading}
                        />
                    )) : (
                        <div className="col-12 text-center">
                            <br /><br /><br />
                            <span className="labelFilter">Não há veículos cadastrados!</span>
                        </div>
                    )}
                </ul>
            </div>
        </div>
    );
}
